import Menu from "@/models/Menu";

// should be cached probably
function menuItem(menu, id) {
  let topLevelItems = menu.categories.reduce((items, category) => {
    if (category.items) {
      return items.concat(category.items);
    } else {
      return items;
    }
  }, []);

  let result = topLevelItems.filter(item => item.id == id);

  return result.length ? result[0] : null;
}

export default {
  methods: {
    async filterOrderItemsByAvailable(orderItems, locationId) {
      let menuSnapshot;

      menuSnapshot = await this.$firestore()
        .collection("menus")
        .withConverter(Menu.firebaseConverter)
        .doc(locationId)
        .get();

      let menu = menuSnapshot.data();

      if (!menu) {
        throw Error("Unable to load menu");
      }

      return orderItems.filter(item => {
        let optionValueId = "";

        if (item.options && item.options.value && item.options.value.id) {
          optionValueId = item.options.value.id;
        }

        // find here first, again sloppy. This should likely be part of the menu model? (time bro, time!)
        let foundMenuItem = menuItem(menu, item.id);
        if (foundMenuItem) {
          if (foundMenuItem.restricted) {
            return false;
          }

          // find the option value id
          if (
            !optionValueId ||
            (foundMenuItem.options &&
              Array.isArray(foundMenuItem.options.values) &&
              foundMenuItem.options.values.filter(
                optionItem => optionItem.id == optionValueId
              ).length)
          ) {
            return true;
          }
        }
        return false;
      });
    }
  }
};
